const config = require("./_application");

const local = require("./_local");
const development = require("./_development");
const uat = require("./_uat");
const abaddon =  require("./_abaddon");
const production = require("./_production");
const staging = require("./_staging");

const overridesConfigs = {
  local,
  development,
  uat,
  abaddon,
  production,
  staging
};
const overrides = overridesConfigs[config.env] || {};
module.exports = Object.assign(config, overrides);
